import React, { useEffect, useRef, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { FaSearch } from 'react-icons/fa';

const Announcement = () => {

  const location = useLocation();
  const outletRef = useRef(null);
  const navigate = useNavigate();
  const [selectedCard, setSelectedCard] = useState();

  useEffect(() => {
    if (outletRef.current) {
      outletRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  }, [location]);

  useEffect(() => {
 window.scrollTo(0,0)
   } ,[location.pathname]);

  const topics = [
    {
      title: 'New Cryptocurrency Listing',
      description: 'Check out the latest coin listings and pairs on Launchpad, Launchpool, Spot, Margin, and Futures markets.',
      icon: '📄',
      route: "announcement-all",
    },
    {
      title: 'Latest Tillionx News',
      description: 'Stay on top of what’s new in Tillionx.',
      icon: '✍️',
      route: 'latest-tillionx-news',
    },
    {
      title: 'Latest Activities',
      description: 'Find promotions that interest you.',
      icon: '🎁',
      route: 'latest-activities',
    },
    {
      title: 'New Fiat Listings',
      description: 'See which new fiat-to-crypto trading pairs are available on Tillionx.',
      icon: '🪙',
      route: 'new-fiat-listings',  
    },
    {
      title: 'API Updates',
      description: 'Learn latest news on API updates.',
      icon: '💻',
      route:'api-updates', 
    },
    {
      title: 'Maintenance Updates',
      description: 'Stay updated on maintenance of various networks and tokens.',
      icon: '🔑',
      route: 'maintenance-updates',
      
    },
    {
      title: 'Crypto Airdrop',
      description: 'Check the latest crypto airdrops supported by Tillionx.',
      icon: '💎',
      route: 'crypto-airdrop',
    },
    {
      title: 'Delisting',
      description: 'Get information on coins or trading pairs to be removed.',
      icon: '🗑️',
      route: 'delisting',
    },
  ];

  const handleCardClick = (e, route) => {
    e.preventDefault();
    setSelectedCard(route);
    navigate(`/announcement/${route}`);
  };

  return (
 <>
  <div className="bg-white dark:bg-gray-900 text-gray-900 dark:text-white transition-colors duration-300">
        <Header />

        <div className="max-w-7xl mx-auto my-16">
       <h2 className='text-3xl mb-8 font-bold'>Announcement</h2>
      <div clsassName='relative'>
         <input type="text" placeholder='Search' className='border text-sm rounded-md py-2 pl-10 w-96 outline-none bg-transparent' />
         <FaSearch className='absolute top-[24%] ml-3 mt-0 text-gray-400' />
          {/* <Notification title="We notify you that">
      You are now obligated to give a star to Mantine project on GitHub
    </Notification> */}
      </div>
        <h2 className='text-2xl my-8 font-bold pb-2 border-b border-primary'>All Topics</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {topics.map((service, index) => (
              <div
                key={index}
                onClick={(e) => handleCardClick(e, service.route)}
                className={`text-xl font-bold ${
                  selectedCard === service.route
                }`}
              >
               <div className='flex cursor-pointer p-4 border rounded-lg hover:shadow-lg hover:border-yellow-500 transition lg:py-8 lg:px-6  py-4 px-2'>
                <div className='mr-6'>{service.icon}</div>
                <div>
                     <div className="text-xs md:text-lg font-medium">
                  {service.title}
                </div>
                <div className='text-sm font-medium text-gray-500'>
                    {service.description}
                </div>
                </div>
              </div>
               </div>
            ))}
          </div>

          <div ref={outletRef}>
            <Outlet />
          </div>
        </div>
        <Footer />
      </div>
 
 </>
  )
};

export default Announcement;